export default __webpack_public_path__ + "static/media/TwitterIcon.a1cacabc.svg";